/* eslint-disable @typescript-eslint/no-unused-vars */
/* for mobx decorators? */
import { Button } from '@progress/kendo-react-buttons';
import { inject, observer } from 'mobx-react';
import React from 'react';

import { IProvider, IProviderAddress } from '../../../../interfaces/ITwilioMessage';
import ChatStore from '../../../../stores/ChatStore';
import SuggestedProvidersStyle, { ProviderName } from './SuggestedProvidersStyles';

export function formatAddress(address: IProviderAddress): string {
  const { addressLine1, addressLine2, locality, region, postalCode, countryCode } = address;
  return `${addressLine1}, ${addressLine2 ? addressLine2 + ',' : ''} ${locality}, ${region}, ${postalCode}${
    countryCode ? `, ${countryCode}` : ''
  }`;
}

interface ISuggestedProvidersProp {
  messageId: string;
  providers: IProvider[];
  onActionClick: (message: string, messageId: string, removeAttachmment?: boolean) => void;
}

export interface IInjectedProps extends ISuggestedProvidersProp {
  chatStore: ChatStore;
}

@inject('chatStore')
@observer
class SuggestedProviders extends React.Component<ISuggestedProvidersProp> {
  protected get injected(): IInjectedProps {
    return this.props as IInjectedProps;
  }

  public render() {
    const { providers, onActionClick, messageId } = this.props;

    const {
      chatStore: { loading },
    } = this.injected;

    if (loading) {
      return null;
    }

    return (
      <SuggestedProvidersStyle>
        {providers &&
          providers.map((provider: IProvider, index: number) => (
            <Button
              onClick={() => {
                onActionClick(provider.name, messageId, true);
              }}
              key={index}
              primary={true}
              look='outline'
            >
              <div>
                <ProviderName>{provider.name}</ProviderName>
                <div>{this.getFormattedDistance(provider.distanceInMeters, provider.address.countryCode)}</div>
                <div>{formatAddress(provider.address)}</div>
              </div>
            </Button>
          ))}
      </SuggestedProvidersStyle>
    );
  }

  private getFormattedDistance = (distanceInMeters: number | undefined, countryCode: string) => {
    if (typeof distanceInMeters !== 'number') {
      return distanceInMeters;
    }

    const distanceUnit = countryCode.toLowerCase().indexOf('us') === -1 ? 'km' : 'mi';

    const distance = distanceUnit === 'km' ? distanceInMeters * 0.001 : distanceInMeters * 0.000621371;
    const distanceRounded = Math.floor(distance * 100) / 100;

    return `${distanceRounded}${distanceUnit}`;
  };
}

export default SuggestedProviders;
